import { z } from 'zod';

export const installSchema = z.object({
  title: z.string().min(1),
  description: z.string().min(1),
  installLabel: z.string().min(1),
  installedLabel: z.string().min(1),
});

export type Install = z.infer<typeof installSchema>;
